/** The prototype's sample pictures, shipped with the app: what a brand-new business sees until it has its own photo and room poster. */
export const SAMPLE_ART = {
  talk: "/img/maya-talk-16x9.jpg",
  live: "/img/maya-thumb-3.jpg",
  host: "/img/maya-host-avatar.jpg",
} as const;
